// extracted by mini-css-extract-plugin
export default {"box":"animated_box__+SU0u","skipAnimation":"animated_skipAnimation__ixEUB","visible":"animated_visible__unR+P"};